import * as Actions from './actions.type';
import * as Mutations from './mutations.type';
import * as Service from './analytics.service';

interface State {
    visitorsAnalytics: any[],
    turnoverAnalytics: any[],
    adaptationsAnalytics: any[],
    demographyAnalytics: any[],
    positionsAnalytics: any[],
    coinsAnalytics: any,
    modulesAnalytics: any[]
}

const store: State = {
    visitorsAnalytics: [],
    turnoverAnalytics: [],
    adaptationsAnalytics: [],
    demographyAnalytics: [],
    positionsAnalytics: [],
    coinsAnalytics: {},
    modulesAnalytics: []
}

const actions = {
    [Actions.GET_ADAPTATIONS_ANALYTICS]: Service.getAdaptationsAnalytics,
    [Actions.GET_DEMOGRAPHY_ANALYTICS]: Service.getDemographyAnalytics,
    [Actions.GET_POSITIONS_ANALYTICS]: Service.getPositionsAnalytics,
    [Actions.GET_TURNOVER_ANALYTICS]: Service.getTurnoverAnalytics,
    [Actions.REPORT_SESSION]: Service.reportSession,
    [Actions.GET_VISITORS_ANALYTICS]: Service.getVisitorsAnalytics,
    [Actions.GET_COINS_ANALYTICS]: Service.getCoinsAnalytics,
    [Actions.GET_MODULE_ANALYTICS]: Service.getModuleAnalytics,
    [Actions.REPORT_MODULE_VISIT]: Service.reportModuleVisit
};

const mutations = {
    [Mutations.SET_VISITORS_ANALYTICS](state: State, visitorsAnalytics: any) {
        state.visitorsAnalytics = visitorsAnalytics;
    },
    [Mutations.SET_ADAPTATIONS_ANALYTICS](state: State, adaptationsAnalytics: any) {
        state.adaptationsAnalytics = adaptationsAnalytics;
    },
    [Mutations.SET_DEMOGRAPHY_ANALYTICS](state: State, demographyAnalytics: any) {
        state.demographyAnalytics = demographyAnalytics;
    },
    [Mutations.SET_POSITIONS_ANALYTICS](state: State, positionsAnalytics: any) {
        state.positionsAnalytics = positionsAnalytics;
    },
    [Mutations.SET_TURNOVER_ANALYTICS](state: State, turnoverAnalytics: any) {
        state.turnoverAnalytics = turnoverAnalytics;
    },
    [Mutations.SET_COINS_ANALYTICS](state: State, coinsAnalytics: any) {
        state.coinsAnalytics = coinsAnalytics;
    },
    [Mutations.SET_MODULES_ANALYTICS](state: State, modulesAnalytics: any) {
        state.modulesAnalytics = modulesAnalytics;
    }
}

export default {
    namespaced: true,
    state: store,
    actions,
    mutations,
};
